import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { ThemeProvider } from "./components/ui/theme-provider"
import { Toaster } from "./components/ui/toaster"
import { TooltipProvider } from "./components/ui/tooltip"
import { AuthProvider } from "./contexts/AuthContext"
import { Login } from "./pages/Login"
import { Verify } from "./pages/Verify"
import { PrivacyStatement } from "./pages/PrivacyStatement"
import { TrialNotice } from "./pages/TrialNotice"
import { SubscriptionChoice } from "./pages/SubscriptionChoice"
import { Layout } from "./components/Layout"
import { ProtectedRoute } from "./components/ProtectedRoute"
import { Meetings } from "./pages/Meetings"
import { Actions } from "./pages/Actions"
import Analytics from "./pages/Analytics"
import { MeetingDetailRouter } from "./components/MeetingDetailRouter"
import { ReadOnlyMeetingDetail } from "./pages/ReadOnlyMeetingDetail"
import { Landing } from "./pages/Landing"


function App() {
  return (
    <AuthProvider>
      <ThemeProvider defaultTheme="light" storageKey="ui-theme">
        <TooltipProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/verify" element={<Verify />} />

              {/* Protected routes */}
              <Route path="/*" element={<ProtectedRoute>
                <Routes>
                  <Route path="subscription-choice" element={<SubscriptionChoice />} />
                  <Route path="privacy" element={<PrivacyStatement />} />
                  <Route path="trial-notice" element={<TrialNotice />} />
                  <Route path="app/*" element={<Layout />}>
                    <Route index element={<Navigate to="/app/meetings" replace />} />
                    <Route path="meetings" element={<Meetings />} />
                    <Route path="meetings/:id" element={<MeetingDetailRouter />} />
                    <Route path="meetings/:id/readonly" element={<ReadOnlyMeetingDetail />} />
                    <Route path="actions" element={<Actions />} />
                    <Route path="analytics" element={<Analytics />} />
                    <Route path="*" element={<Navigate to="/app/meetings" replace />} />
                  </Route>
                </Routes>
              </ProtectedRoute>} />
            </Routes>
            <Toaster />
          </Router>
        </TooltipProvider>
      </ThemeProvider>
    </AuthProvider>
  )
}

export default App
